import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { WindowRef } from '@planone/shared/util-browser-api';
import { Tag } from '@planone/shared/util-interfaces';
import { stringifyFilter } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-expandable-chip-list',
  templateUrl: './expandable-chip-list.component.html',
  styleUrls: ['./expandable-chip-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableChipListComponent implements OnChanges, AfterContentChecked {
  @Input() fairId?: string;
  @Input() chips: Tag[] = [];
  @Input() threshold = 0;
  @Input() offset = true;
  @Input() chipsListClickable = true;

  @ViewChild('referenceElement') referenceElement?: ElementRef;

  maxHeight = 0;
  collapsedHeight = 0;
  chipsOverflowing = false;
  chipsExpanded = false;

  private identifyChipOverflow() {
    let lines = 5;

    if (this.window.nativeWindow.innerWidth >= 600) {
      lines = 3;
    } else if (this.window.nativeWindow.innerWidth >= 1200) {
      lines = 2;
    }

    this.collapsedHeight = 38 * lines;

    if (this.referenceElement) {
      this.chipsOverflowing = this.referenceElement.nativeElement.offsetHeight > this.collapsedHeight;
      this.maxHeight = this.chipsExpanded ? this.referenceElement.nativeElement.offsetHeight : this.collapsedHeight;
    }
  }

  constructor(private window: WindowRef) {}

  ngAfterContentChecked() {
    this.identifyChipOverflow();
  }

  ngOnChanges() {
    this.identifyChipOverflow();
  }

  @HostListener('window:resize')
  onResize() {
    this.identifyChipOverflow();
  }

  toggle() {
    this.chipsExpanded = !this.chipsExpanded;
  }

  stringifyFilter = stringifyFilter;

  trackByChip(index: number, chip: { id: string }) {
    return chip.id ?? index;
  }
}
